import type { DTBPackage } from '../_types/dtb';

export function dtbPackageHasDraftDtbs(pkg: DTBPackage): boolean {
  return (pkg.dtbs ?? []).some((dtb) => (dtb.status ?? '').toUpperCase() === 'DRAFT');
}

export function isDtbPackageEligibleForAssignmentOrDistribution(pkg: DTBPackage): boolean {
  const packageApproved = (pkg.status ?? '').toUpperCase() === 'APPROVED';
  const hasDtbs = (pkg.dtbs?.length ?? 0) > 0;
  return packageApproved && hasDtbs && !dtbPackageHasDraftDtbs(pkg);
}
